<template>
  <a-drawer
    :open="open"
    :width="480"
    class="custom-class"
    root-class-name="root-class-name"
    placement="right"
    @close="close"
  >
    <Text :type="'subHeader'" :text="'Price Log Exemptions'" />
    <div>
      <div class="mt-4" v-if="businessLists.length > 0">
        <div class="mt-6">
          <LabelText :forVal="'customerSelect'" />
          <Loader v-if="loadingExemptions" />
          <div v-if="!loadingExemptions">
            <div class="mt-4" v-if="businessListsActualNames.length > 0">
              <div class="mt-6">
                <LabelText
                  :forVal="'customerSelect'"
                  :labelText="
                    activeCustomers.length === 0
                      ? 'No exemptions records found, Add Customers to exempt from price control'
                      : 'Select customer(s) to add to exemption'
                  "
                />
                <br />

                <a-select
                  v-model:value="activeCustomers"
                  mode="multiple"
                  size="large"
                  style="width: 100%"
                  placeholder="Please select"
                  :options="businessListsActualNames"
                  @change="handleChangeExemptions"
                  :filter-option="filterOptionVal"
                ></a-select>
              </div>
              <div class="mt-8">
                <FormSubmitInput
                  :val="'Submit'"
                  @click="updateExemptionLists"
                  :loading="showLoader"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-drawer>
</template>

<script>
//Library
import moment from "moment";
import { useToast } from "vue-toastification";
import Loader from "@/components/UI/Loader";
//services
import depotService from "@/services/depot-service";
import businessService from "@/services/business-service";
import settingService from "@/services/settings-service";
//component
import FormSubmitInput from "../../../UI/Inputs/FormSubmitInput.vue";
import Text from "../../../UI/Text/Text.vue";
import FadedBorderWrapper from "../../../UI/Wrappers/FadedBorderWrapper.vue";
import LabelText from "../../../UI/Text/LabelText.vue";

export default {
  components: { Text, FadedBorderWrapper, FormSubmitInput, LabelText, Loader },
  props: ["open", "close", "data", "getPriceChangeLog"],
  data() {
    return {
      productVolume: "",
      productName: "",
      newPrice: "",
      startDate: "",
      businessListsActualNames: [],
      businessLists: [],
      loadingExemptions: false,
      showLoader: false,
      activeCustomers: [],
      endDate: "",
      toast: useToast(),
      activeProducts: [],
      loading: false,
      productPrice: "",
      newVolume: "",
      todayDate: moment().format("YYYY-MM-DD"),
    };
  },

  methods: {
    async fetchBusinesses() {
      try {
        const result = await businessService.fetchBusinessDropdown();
        if (result) {
          this.businessLists = result.data.map((data) => ({
            label: data.name,
            value: data.id,
          }));

          this.businessListsActualNames = result.data.map((data) => ({
            value: data.name,
          }));
        }
      } catch (err) {}
    },
    async getExemptionLists(id) {
      const data = {
        controlId: id,
      };

      this.loadingExemptions = true;
      try {
        const result = await settingService.getExemption(data);
        this.loadingExemptions = false;
        if (result.data.length > 0) {
          let names = [];
          for (let person of result.data) {
            names.push(person.customerName);
          }
          this.activeCustomers = names;
        } else {
          this.activeCustomers = [];
        }
      } catch (error) {
        this.activeCustomers = [];

        this.loadingExemptions = false;
      }
    },
    handleChangeExemptions(value) {
      this.activeCustomers = value;
    },
    filterOption(input, option) {
      return option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    filterOptionVal(input, option) {
      return option?.value?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    handleChangeDepot(value) {
      console.log(value);
      this.depot = value;
      this.fetchStockControl();
    },
    editProduct(product) {
      this.productName = product.productName;
      this.newPrice = product.newPrice;
      // this.productVolume = product.productVolume;
      this.startDate = product.startDate;
      this.endDate = product.endDate;
      this.productPrice = product.productPrice;
      // this.newVolume = product.newVolume;
    },
    getArrayByNames(arr, listID) {
      const idByArray = {};
      for (const newArr of arr) idByArray[newArr.label] = newArr;
      const result = listID.map((label) => idByArray[label]);
      return result;
    },
    getArrayByID(arr, listID) {
      const idByArray = {};
      for (const newArr of arr) idByArray[newArr.value] = newArr;
      const result = listID.map((value) => idByArray[value]);
      return result;
    },
    async updateExemptionLists(e) {
      e.preventDefault();
      var obtainUserLists = this.getArrayByNames(
        this.businessLists,
        this.activeCustomers
      );

      const stExemptionIds = obtainUserLists.map((item) => item.value);
      console.log(obtainUserLists)

      const data = {
        controlId: this.data.id,
        depotId: this.data.depotId,
        controlType: 2,
        customerId: stExemptionIds,
      };
      console.log(data, "here");
      this.showLoader = true;
      try {
        const result = await settingService.updateExemptionLists(data);
        this.showLoader = false;
        if (result) {
          console.log(result);
          this.toast.success("Exemption list updated Successfully", {
            timeout: 2000,
          });
          this.close();
        }
      } catch (error) {
        this.showLoader = false;
      }
    },
  },
  watch: {
    data() {
      if (this.data) {
        this.getExemptionLists(this.data.id);
      }
    },
  },
  mounted() {
    this.fetchBusinesses();
  },
};
</script>

<style>
.ant-drawer-content-wrapper {
  /* drawer size */
  /* width: 460px !important; */
  background: red;
}

@media (max-width: 768px) {
  .ant-drawer-content-wrapper {
    width: 100% !important;
  }
}
</style>
